import React from 'react';
import classnames from 'classnames';
import { EventStatus } from '../../../../../api/events.dao';
import { MeetingProgress } from '../../../../../api/control.dao';

import './progress-bar.scss';
import { CircleCheckbox } from '../circle-checkbox/circle-checkbox';

export interface IProgressItem {
    type: string;
    status?: EventStatus | MeetingProgress;
    active: boolean;
    disabled?: boolean;
    default?: boolean;
    label?: string | object;
}
interface IProps {
    progressBarFields: IProgressItem[];
    handleClick: (e) => void;
    disabled?: boolean;
}


const ProgressBar = (props: IProps) => {

    const { progressBarFields, handleClick, disabled = false } = props;
    return (
        <div className={classnames('meeting-status-bar', {'disabled': disabled})} >
            <div className='progress-bar-wrapper'>
                {progressBarFields.map((item: IProgressItem, index) => item.type === 'Step' ? (
                  <div className='step-wrapper' key={index}>
                      <CircleCheckbox
                        item={item}
                        handleClick={handleClick}
                      />
                      <label>{item.label}</label>
                  </div>
                ) : (<div key={index} className={classnames('bar-line', {'bar-line--active': item.active})}/>
                ))}
            </div>
        </div>
    );
};

export { ProgressBar } ;

